const config = {
  apiPathUrl: 'api/v1/nms',
  apiBaseUrl: 'https://prod.api.smart.juganu.com',
  get apiUrl() {
    return `${this.apiBaseUrl}/${this.apiPathUrl}`;
  },
  getEnvironment() {
    return 'prod';
  }
};

export default config;